import {h} from 'preact';
import React, {createPortal} from "preact/compat";
import {Component} from "preact";
import Interactable from "../canvas/interactable";
import MenuContentEditItem from "./MenuContentEditItem";
import store from "../store";
import {connect} from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import {setIsLeftMenuVisible, setIsMOEditModal} from "../actions";
import util from "../util";
import $ from "jquery";
import MenuObject from "../canvas/menu-object";
import Moveable from "moveable";
import {decomposeMatrix} from "../canvas/interactable-helpers";
import BackArrow from "./svg/BackArrow";
import NextArrow from "./svg/NextArrow";
import CloseIcon from "./svg/CloseIcon";
import MOBackIcon from "./svg/MOBackIcon";
import MenuObjectEditNameNotes from "./MenuObjectEditNameNotes";

const M_WIDTH = 320;
const M_HEIGHT = 488;
const MODAL_OFFSET = 20;
const CENTRAL_POSITION_DESIGN_SIZES = ['biz-card-landscape', 'biz-card-square', 'biz-card-circular', 'loyalty-card-landscape', 'sticker-landscape'];

export default @connect(reduce, actions)
class MOEditModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            $element: props.$element,
            editSubtype: "item",
        };
        this.moveable = null;

        this.setEditSubtype = (subtype) => {
            this.setState({editSubtype: subtype});
        }
    }

    goToPrevItem() {
        MenuObject.moPaginationPrev();
    }

    goToNextItem() {
        MenuObject.moPaginationNext();
    }

    deleteItem() {
        MenuObject.moPaginationDelete();
    }

    onModalClick(e) {
        e.stopPropagation();
    }

    getPagePosition() {
        const selectedInteractables = Interactable.getSelected();
        if (selectedInteractables.length !== 1) return {};
        const rectInfo = selectedInteractables[0].getRect();
        if (!rectInfo) return {};

        const useCentralPosition = !!CENTRAL_POSITION_DESIGN_SIZES.find(it => it === store.getState().designSize);

        const rightMenuRect = $('.right-menu')[0].getBoundingClientRect();
        const mainNavRect = $('.main-nav')[0].getBoundingClientRect();
        const elementRect = selectedInteractables[0].getElement()[0].getBoundingClientRect();

        const modalTopLeft = rectInfo.left + rectInfo.width + MODAL_OFFSET;
        const modalTopRight = modalTopLeft + M_WIDTH;
        const modalBottomLeft = elementRect.top + M_HEIGHT;

        const canDisplayInRight = modalTopRight < rightMenuRect.x;

        let diff = 0;
        // bottom
        const underDiff = modalBottomLeft + MODAL_OFFSET - mainNavRect.bottom;
        if (underDiff > 0) {
            diff = -underDiff;
        } else {
            // top
            const elementTop = elementRect.top;
            const contextBarRect = $('.context-bar')[0]?.getBoundingClientRect() ?? {bottom: 0};

            const overDiff = contextBarRect.bottom + MODAL_OFFSET - elementTop;
            if (overDiff > 0) {
                diff = overDiff;
            }
        }

        let pos;
        if (canDisplayInRight) {
            pos = {
                top: `${rectInfo.top + diff}px`,
                left: `${rectInfo.left + rectInfo.width + MODAL_OFFSET}px`,
            };
        } else {
            pos = {
                top: `${rectInfo.top + diff}px`,
                left: `${rectInfo.left - M_WIDTH - MODAL_OFFSET}px`,
            };
        }

        if (useCentralPosition) {
            pos.left = `${rectInfo.left + (rectInfo.width / 2) - (M_WIDTH / 2)}px`
        }

        return pos;
    }

    maybeCloseLeftMenu($modal) {
        const leftNavRect = $('#app-aside')[0].getBoundingClientRect();
        const modalRect = $modal[0].getBoundingClientRect();

        if (modalRect.left < leftNavRect.right) {
            if (store.getState().isLeftMenuVisible) {
                if (modalRect.left === 0) return;
                store.dispatch(setIsLeftMenuVisible(false));
                store.dispatch(setIsMOEditModal(false));
                util.nextTick(() => {
                    Interactable.adjustSelectionBoxes();
                    util.nextTick(() => {
                        store.dispatch(setIsMOEditModal(true));
                    });
                });
            } else {
                // bottom?
            }
        }
    }

    componentDidMount() {
        const $modal = jQuery('.mo-edit-modal');

        if ($modal && $modal.length) {
            this.initMoveable($modal);
            this.ensureItemIsSelected();
            //this.maybeCloseLeftMenu($modal);
            this.checkModalIsVisible($modal);
        }
        window['refreshMOModal'] = () => {
            this.forceUpdate();
        }
    }

    checkModalIsVisible($modal) {
        if (!this.isElementInViewport($modal)) {
            sessionStorage.removeItem('mo-edit-position');
            util.nextTick(() => {
                this.forceUpdate();
            });
        }
    }

    ensureItemIsSelected() {
        MenuObject.ensureItemIsSelected(this.props.$element);
    }

    isElementInViewport(element, fullyInView) {
        const headerHeight = 128;
        const pageTop = $(window).scrollTop() + headerHeight;
        const pageBottom = pageTop - headerHeight + $(window).height();
        const elementTop = $(element).offset().top;
        const elementBottom = elementTop + $(element).height();

        if (fullyInView === true) {
            return ((pageTop < elementTop) && (pageBottom > elementBottom));
        } else {
            return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
        }
    }

    initMoveable($modal) {
        this.moveable = new Moveable(document.body, {
            target: $modal[0],
            hideDefaultLines: true,
            origin: false,
            draggable: true,
            checkInput: true,
            dragTarget: $modal.find('.drag-handle')[0],
        });

        const onDragStart = (e) => {
            const transform = $modal.css('transform');
            const matrix = decomposeMatrix(new DOMMatrix(transform));
            e.set([matrix.translateX, matrix.translateY]);
        };
        const onDrag = (e) => {
            e.target.style.transform = e.transform;
        };
        const onDragEnd = () => {
            window.sessionStorage.setItem('mo-edit-position', $('.mo-edit-modal').attr('style'));
        };

        this.moveable
            .on("dragStart", onDragStart)
            .on("drag", onDrag)
            .on("dragEnd", onDragEnd);
    }

    componentWillUnmount() {
        this.moveable?.destroy();
        window['refreshMOModal'] = null;
    }

    getCssStyle() {
        const prevPosition = window.sessionStorage.getItem('mo-edit-position');
        if (prevPosition != null) {
            return prevPosition;
        }

        return {
            position: 'absolute',
            background: '#fefefe',
            transform: 'none',
            ...this.getPagePosition()
        };
    }

    addItem() {
        MenuObject.moAddItem(this.props.$element);
    }

    closeModal() {
        store.dispatch(setIsMOEditModal(false));
    }

    onBackClick() {
        $('.icon-widget-go-back').trigger('click');
    }

    render(props, state) {
        const $element = props.$element;
        const activeIdx = store.getState().moSelectedItemIdx || 0;

        Interactable.of(this.props.$element).refreshSortable();

        return createPortal(<div style={this.getCssStyle()} className={`menu-object-content mo-edit-modal ${props.editType === "name" ? 'mo-name-modal' : ''} ${props.editType === "notes" ? 'mo-notes-modal' : ''}`} onClick={this.onModalClick}>
            <div className={'drag-handle'}></div>

            {props.editType === "items" && state.editSubtype === "icons" &&
            <MOBackIcon className="back-icon" onClick={() => this.setEditSubtype('item')}/>}
            {props.editType === "items" && state.editSubtype === "icons" &&
            <div className="edit-icon-header">Add menu icon</div>}

            <div className={'close-icon'} onClick={this.closeModal.bind(this)}><CloseIcon/></div>
            {props.editType === "items" &&
            <MenuContentEditItem
                $element={$element}
                activeIdx={activeIdx}
                active={store.getState().menuObjectItems[activeIdx]}
                contentEditMode={state.editSubtype}
                setContentEditMode={this.setEditSubtype}
                uploadedIcons={props.uploadedIcons}
                setUploadedIcons={props.setUploadedIcons}
            />
            }
            {props.editType === "name-notes" &&
            <MenuObjectEditNameNotes 
                $element={$element} 
                closeModal={this.closeModal.bind(this)} 
                contentEditMode={state.editSubtype}
            />}
            {((props.editType === "items" && state.editSubtype === "item") || props.editType === 'name-notes') &&<div className={'pagination'}>
                <div className={'prev'} onClick={this.goToPrevItem}><BackArrow/></div>
                <div className={'delete'} onClick={this.deleteItem}><a className={'btn medium secondary4'}>Delete</a></div>
                <div className={'add'} onClick={this.addItem.bind(this)}><a className={'btn medium secondary5'}>+ New</a></div>
                <div className={'done'} onClick={this.closeModal.bind(this)}><a className={'btn medium primary'}>Done</a></div>
                <div className={'next'} onClick={this.goToNextItem}><NextArrow/></div>
            </div>}
        </div>, document.getElementById('modals'));
    }
}
